<div class="contacts-form-wrapper">
  <div class="contacts-form-scroll-content">
    <dx-validation-group #companyValidationGroup>
      <div class="gpd-form-grid">
        <div class="gpd-form-column">
          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="building" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@companyData">Company Data</span>
            </div>

            <div class="gpd-form-row">
              <div class="gpd-form-field">
                <label class="gpd-form-label gpd-form-required"><span i18n="@@name">Name</span></label>
                <dx-text-box class="gpd-input" [(value)]="formData.name" i18n-placeholder="@@companyNamePlaceholder" placeholder="e.g. Sample Company Ltd.">
                  <dx-validator>
                    <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@phone">Phone</label>
                <dx-text-box class="gpd-input" [(value)]="formData.phone" [maxLength]="50" i18n-placeholder="@@phonePlaceholder" placeholder="e.g. +49 30 1234567"></dx-text-box>
              </div>
            </div>
          </div>

          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="location" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@address">Address</span>
            </div>

            <div class="gpd-form-row">
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@address">Address</label>
                <dx-text-box class="gpd-input" [(value)]="formData.address" [maxLength]="50" i18n-placeholder="@@addressPlaceholder" placeholder="e.g. Main Street 1"></dx-text-box>
              </div>
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@addition">Addition</label>
                <dx-text-box class="gpd-input" [(value)]="formData.addition" [maxLength]="50" i18n-placeholder="@@additionPlaceholder" placeholder="e.g. Building 2"></dx-text-box>
              </div>
            </div>

            <div class="gpd-form-row">
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@zipcode">Zipcode</label>
                <dx-text-box class="gpd-input" [(value)]="formData.zipcode" [maxLength]="50" i18n-placeholder="@@zipcodePlaceholder" placeholder="e.g. 12345"></dx-text-box>
              </div>
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@city">City</label>
                <dx-text-box class="gpd-input" [(value)]="formData.city" [maxLength]="50" i18n-placeholder="@@cityPlaceholder" placeholder="e.g. Berlin"></dx-text-box>
              </div>
            </div>

            <div class="gpd-form-row gpd-form-row--half">
              <div class="gpd-form-field">
                <label class="gpd-form-label" i18n="@@country">Country</label>
                <dx-select-box
                  class="gpd-input"
                  [readOnly]="false"
                  [(value)]="formData.countryId"
                  [dataSource]="countriesByLanguageList"
                  (onSelectionChanged)="handleCountryChange(formData.countryId)"
                  displayExpr="countryName"
                  valueExpr="countryId"
                  acceptCustomValue="false"
                  i18n-placeholder="@@pleaseSelect"
                  placeholder="Please Select"
                ></dx-select-box>
              </div>
            </div>
          </div>

          <!-- Contact persons have nothing to show yet — this company doesn't exist until Save,
               so a person can't be linked to it. Header-only, matching the Figma empty state,
               rather than a non-functional "Add Person" affordance. -->
          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="user-multiple" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@contactPersons">Contact Persons</span>
            </div>
            <p class="gpd-form-empty-hint" i18n="@@availableAfterSaveContactPersons">Available once the contact is saved.</p>
          </div>
        </div>

        <div class="gpd-form-column gpd-form-column--side">
          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="tag" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@tags">Tags</span>
            </div>

            <!-- The tag-box's own chip rendering is hidden (see .cap-tags-dropdown in the CSS) —
                 selected tags show as pills below; this stays purely a control for
                 adding/removing tags via its dropdown checklist. DevExtreme only renders its own
                 placeholder when the value is genuinely empty, so a static one is layered on top
                 instead — always visible, steps aside only while actually focused. -->
            <div class="cap-tags-dropdown-wrapper">
              <dx-tag-box
                class="gpd-input cap-tags-dropdown"
                [items]="contactTags"
                displayExpr="title"
                valueExpr="id"
                [showSelectionControls]="true"
                [showDropDownButton]="true"
                applyValueMode="useButtons"
                [(value)]="formData.tags"
                [inputAttr]="{ 'aria-label': 'Tags' }"
              ></dx-tag-box>
              <span class="cap-tags-placeholder" i18n="@@assignTags">Assign tags</span>
            </div>

            <div class="contact-tag-container" *ngIf="formData.tags?.length">
              <gpd-pill
                *ngFor="let tag of formData.tags"
                [text]="getTag(tag)"
                backgroundColor="var(--color-secondary)"
                color="var(--color-primary)"
                [removable]="true"
                (onRemove)="removeTag(tag)"
              ></gpd-pill>
            </div>
          </div>

          <!-- Projects/Contracts have nothing to show yet — this contact doesn't exist until Save,
               so it can't be linked to a project or contract. Header-only, matching the Figma
               empty state, rather than a non-functional "Add" affordance. -->
          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="solar-panel" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@projects">Projects</span>
            </div>
            <p class="gpd-form-empty-hint" i18n="@@availableAfterSaveProjects">Available once the contact is saved.</p>
          </div>

          <div class="gpd-form-card">
            <div class="gpd-form-card-header">
              <app-svg-icon icon="contracts" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@contractsCaps">Contracts</span>
            </div>
            <p class="gpd-form-empty-hint" i18n="@@availableAfterSaveContracts">Available once the contact is saved.</p>
          </div>
        </div>
      </div>
    </dx-validation-group>
  </div>

  <app-form-footer>
    <app-gpd-button footerRight i18n-text="@@cancel" text="ABORT" type="secondary" icon="cancel" (onClick)="handleAbort()"></app-gpd-button>
    <app-gpd-button footerRight i18n-text="@@save" text="CONFIRM" type="primary" icon="check" iconColor="white" (onClick)="handleSubmitButton($event)"></app-gpd-button>
  </app-form-footer>

  <app-validation-toast #validationToast></app-validation-toast>
</div>

<dx-toast [visible]="toastVisible" [type]="type" message="{{ message }}" position="bottom center" width="fit-content">
</dx-toast>
